import { render } from "./examRecordPaper.vue?vue&type=template&id=7a65adfe&scoped=true"
import script from "./examRecordPaper.vue?vue&type=script&lang=js"
export * from "./examRecordPaper.vue?vue&type=script&lang=js"

import "./examRecordPaper.vue?vue&type=style&index=0&id=7a65adfe&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a65adfe"]])

export default __exports__